import { createFileRoute } from '@tanstack/react-router';

import ExportSettingsTab from '@/pages/administration/tabs/export-settings';

export const Route = createFileRoute('/administration/export-settings/')({
  component: ExportSettingsTab,
});
